let country = null
document.addEventListener("DOMContentLoaded", function() {


  fetch('https://api.bigdatacloud.net/data/reverse-geocode-client?localityLanguage=es')
  .then(res => res.json())
  .then(data => {
    country = data     
    showAlertDiscount(1)  
    if(data.countryCode == "US"){
    }
  })
  .catch(err => console.log('Error:', err));

/* ------------------------------------------
   1) Delegación de eventos (clics confiables)
-------------------------------------------*/

document.addEventListener("click", (e) => {

  if (e.target.closest("#cart-and-account .level-body > button")) {
    showAlertDiscount(2);
    if (country && country.countryCode === "US") {}
    return;
  }

  if (e.target.closest("#cart-and-account a.level-body") ||
      e.target.closest("#cart-and-account .bottom > div > button")) {
    showAlertDiscount(3);
    if (country && country.countryCode === "US") {}
    return;
  }

  if (e.target.closest("#AddToCart")) {
    showAlertDiscount(4);
    if (country && country.countryCode === "US") {}
    return;
  }

});



/* ------------------------------------------------
   2) MutationObserver + Debounce
      → evita ejecuciones repetidas
------------------------------------------------ */

const cartContainer = document.querySelector("#cart-and-account");

// pequeña función debounce
let debounceTimer = null;
const DEBOUNCE_DELAY = 200; // ajusta si quieres menos/más

if (cartContainer) {
  const observer = new MutationObserver((mutations) => {

    let changes = false;

    mutations.forEach(m => {
      if (m.addedNodes.length > 0 || m.removedNodes.length > 0) {
        changes = true;
      }
    });

    if (changes) {
      clearTimeout(debounceTimer);

      // Solo se ejecutará UNA VEZ cada X ms
      debounceTimer = setTimeout(() => {

        if (country && country.countryCode === "US") {
          showAlertDiscount(); 
        }

      }, DEBOUNCE_DELAY);
    }

  });

  observer.observe(cartContainer, { childList: true, subtree: true });
}




(function() {
  const nuevasImagenes = [
    "https://cdn.shopify.com/s/files/1/0337/3793/files/1_33bd6331-a1ef-4935-b52f-f5c6a899189a.png?v=1762450191",
    "https://cdn.shopify.com/s/files/1/0337/3793/files/2_136204cc-9d99-43c0-b5c3-508e31c251f3.png?v=1762450191",
    "https://cdn.shopify.com/s/files/1/0337/3793/files/3_e8066abc-6b39-4fc8-9686-e83d0dc6e75c.png?v=1762450191"
  ];

  let observer = null;

  function reemplazarImagenes() {
    const imagenes = document.querySelectorAll('.slp_fcec57 img');
    if (imagenes.length === 0) return false;

    imagenes.forEach((img, index) => {
      // Evitar sobreescribir si ya fue reemplazada
      if (!img.dataset.replaced && nuevasImagenes[index]) {
        img.src = nuevasImagenes[index];
        img.dataset.replaced = "true"; // marca para no tocarla más
      }
    });

    return true;
  }

  function iniciarObservador() {
    if (observer) observer.disconnect(); // por si ya hay uno activo

    observer = new MutationObserver((mutations) => {
      let cambioRelevante = false;

      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0 || mutation.type === "childList") {
          // Si el contenedor o sus hijos cambian, marcar para re-evaluar
          cambioRelevante = true;
          break;
        }
      }

      if (cambioRelevante) {
        reemplazarImagenes();
      }
    });

    // Observar el body entero, ya que Shopify o scripts externos reemplazan secciones completas
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Ejecutar una vez el reemplazo y activar el observador
  function init() {
    reemplazarImagenes();
    iniciarObservador();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();


  
}); // END ON READY





const showAlertDiscount = async () => {


  // 1. ESPERAR SIEMPRE EL CARRITO
  let cartResponse = null;
  let totalcart = null;

  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    cartResponse = cart;
    totalcart = cart.total_price;
  } catch (error) {
    console.error("Error al obtener el carrito:", error);
    return; // detener para evitar errores
  }

  // 2. ESPERAR A QUE EXISTA EL ELEMENTO DEL DRAWER
  const elemento = await waitForElement(".flex.justify-between.items-center.default-x-padding.py-4");

  let txtInsert = "";
  let limit = 20000;

  // ============================
  // MAPEO CORRECTO variant → <p>
  // ============================
  const variantMap = {};

  document.querySelectorAll("#cart-and-account .top").forEach(top => {
    const link = top.querySelector('a[href*="variant="]');
    const p = top.querySelector("p");

    if (link && p) {
      const url = new URL(link.href, window.location.origin);
      const variant = url.searchParams.get("variant");

      // asignar data-variant al p
      p.dataset.variant = variant;

      // soportar múltiples p por variant
      if (!variantMap[variant]) variantMap[variant] = [];
      variantMap[variant].push(p);
    }
  });

  // ============================
  // INSERTAR PRECIOS / DESCUENTOS
  // ============================
  cartResponse.items.forEach(item => {
    const variantId = String(item.id);
    const pList = variantMap[variantId];

    if (pList && pList.length > 0) {
      pList.forEach(p => {
        p.innerHTML = `
          <span class="original">${formatMoney(item.final_line_price)}</span>
          <span class="discount">${formatMoney(item.line_price)}</span>
        `;
      });
    }
  });

  // ============================
  // MENSAJE: "You're saving 30%"
  // ============================
  setTimeout(() => {
    if (cartResponse.item_count > 0) {
      const form = document.querySelector('#cart-drawer form');

      if (form && !document.querySelector('#wrapper-txt-custom-2')) {
        const wrapper = document.createElement('div');
        wrapper.id = 'wrapper-txt-custom-2';
        wrapper.innerHTML = `<p id="show--txt-2">You're saving 30% for BFCM!</p>`;
        form.prepend(wrapper);
      }
    }
  }, 100);

  // ============================
  // FREE SHIPPING BANNER
  // ============================
  if (totalcart < 1) {
    txtInsert = "Free Shipping for orders over $200.00!";
  } else if (totalcart > 1 && totalcart < limit) {
    let totalNeed = ((limit - totalcart) / 100).toFixed(2);
    txtInsert = `Psst, you're $${totalNeed} away from free shipping`;
  } else {
    txtInsert = "That's a good looking' cart, shipping is on us";
  }

  let wrapperText = document.getElementById("wrapper-txt-custom");
  if (wrapperText) wrapperText.remove();

  elemento.insertAdjacentHTML(
    "beforeend",
    `<div id="wrapper-txt-custom"><p id="show--txt">${txtInsert}</p></div>`
  );

  // ============================
  // UTILIDADES
  // ============================
  function formatMoney(cents) {
    return (cents / 100).toLocaleString("en-US", {
      style: "currency",
      currency: "USD"
    });
  }
};


// Función para esperar elementos dinámicos (super estable)
function waitForElement(selector) {
  return new Promise(resolve => {
    const el = document.querySelector(selector);
    if (el) return resolve(el);

    const obs = new MutationObserver(() => {
      const el2 = document.querySelector(selector);
      if (el2) {
        obs.disconnect();
        resolve(el2);
      }
    });

    obs.observe(document.body, { childList: true, subtree: true });
  });
}
